/* global axios */
import ApiClient from '../ApiClient';

class EventDocumentsAPI extends ApiClient {
  constructor() {
    super('planning/events', { accountScoped: true });
  }

  base(eventId) {
    return `${this.url}/${eventId}/documents`;
  }

  libraryUrl() {
    return `${this.apiVersion}/accounts/${this.accountIdFromRoute}/planning/document-library`;
  }

  getLibrary(knowledgebaseId = null) {
    const params = knowledgebaseId ? { knowledgebase_id: knowledgebaseId } : {};
    return axios.get(this.libraryUrl(), { params });
  }

  uploadToLibrary(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.libraryUrl()}/records`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getAll(eventId) {
    return axios.get(this.base(eventId));
  }

  create(eventId, payload = {}) {
    if (payload.file) {
      const formData = new FormData();
      Object.keys(payload).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null) {
          formData.append(key, payload[key]);
        }
      });
      return axios.post(this.base(eventId), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(this.base(eventId), payload);
  }

  update(eventId, id, payload) {
    return axios.patch(`${this.base(eventId)}/${id}`, payload);
  }

  destroy(eventId, id) {
    return axios.delete(`${this.base(eventId)}/${id}`);
  }

  sendPreview(eventId, id) {
    return axios.get(`${this.base(eventId)}/${id}/send_preview`);
  }

  sendDocument(eventId, id, payload = {}) {
    return axios.post(`${this.base(eventId)}/${id}/send_document`, payload);
  }

  remind(eventId, id, payload = {}) {
    return axios.post(`${this.base(eventId)}/${id}/remind`, payload);
  }

  voidDocument(eventId, id) {
    return axios.post(`${this.base(eventId)}/${id}/void`);
  }
}

export default new EventDocumentsAPI();
